import { makeStyles } from '@material-ui/core'
import React from 'react'
import LoaderIcon from '../../../../components/svgIcons/LoaderIcon'

const LoadingContent = () => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.iconContaier}>
        <LoaderIcon />
      </div>
    </div>
  )
}

export default LoadingContent

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 130,
  },
  iconContaier: {
    animation: '$spin 1s linear infinite',
  },
  '@keyframes spin': {
    from: {
      transform: 'rotate(0deg)',
    },
    to: {
      transform: 'rotate(360deg)',
    },
  },
})
